import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { DatabaseTooltip } from '~src/spacesPlatform/components/tooltip/DatabaseTooltip';
import { getCommonDatabaseInfo, getGraphQLId, isContentInfoDatabase } from '~src/spacesPlatform/models/CommonDatabaseInfo';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { DatabaseThumbnail } from './DatabaseThumbnail';

export class DatabaseCard extends ContentCard {

    public render() {
        const { content, urls, allowDragAndDrop, hovered, selected } = this.props;
        const commonDatabase = getCommonDatabaseInfo(content);
        const contentUrl = getDatabaseContentUrl(urls, content);
        return (
            <div className={CardViewStyles.Card}>
                <DatabaseThumbnail allowDragAndDrop={allowDragAndDrop}
                                    content={commonDatabase}
                                    contentUrl={contentUrl}
                                    hovered={hovered}
                                    selected={selected}
                                    aria-label={content.name}
                />
                <div className={CardViewStyles.ActionRow}>
                    <span data-tb-test-id="database-name" className={CardViewStyles.ActionRowName} title={content.name}>
                        {content.name}
                    </span>
                    <span>
                        <CardPopoverWidget
                            content={content}
                            onTriggerClick={this.handleShowPopover}
                            popoverContent={this.renderPopoverContent()}
                            title={Messages.databaseDetails()}
                        />
                    </span>
                    {this.renderActionsMenu()}
                </div>
                <div className={CardViewStyles.CardDescription}>
                    {this.getDescription()}
                </div>
            </div>
        );
    }

    private renderPopoverContent = () => <DatabaseTooltip content={this.props.content}
                            urls={this.props.urls}/>;
}

export function getDatabaseContentUrl(urls: SpacesSiteUrls, content: IContentInfo): string {
    if (isContentInfoDatabase(content)) {
        const contentId = getGraphQLId(content);
        return urls.catalogDatabaseUrl(contentId);
      }

    return getContentUrlForItem(content, urls);
}
